import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';

export const metaOverrideSet = fr.metaOverride({ BaseOverride })
  .nameOverride(['limit', 'offset', 'sort'], { hidden: true })
  .typeOverride('picklist', {
    _component: () => Autocomplete,
  });
